var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImg3Cinza(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 50,
    viewBox: "0 0 75 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 50,
    rx: 4,
    fill: "#ACACAC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.125 14.7916C21.4621 14.7916 22.7445 15.3228 23.69 16.2683C24.6355 17.2138 25.1666 18.4962 25.1666 19.8333C25.1666 21.1704 24.6355 22.4528 23.69 23.3983C22.7445 24.3438 21.4621 24.875 20.125 24.875C18.7878 24.875 17.5055 24.3438 16.56 23.3983C15.6145 22.4528 15.0833 21.1704 15.0833 19.8333C15.0833 18.4962 15.6145 17.2138 16.56 16.2683C17.5055 15.3228 18.7878 14.7916 20.125 14.7916M20.125 27.3958C25.696 27.3958 30.2083 29.6519 30.2083 32.4375V34.9583H10.0416V32.4375C10.0416 29.6519 14.5539 27.3958 20.125 27.3958Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 37.5,
    y: 14,
    width: 33.75,
    height: 20.5,
    rx: 2,
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg3Cinza);
export default __webpack_public_path__ + "static/media/img3cinza.420a6d3d3bf7ba381d65fb77407a5890.svg";
export { ForwardRef as ReactComponent };